export default "__VITE_ASSET__IONJoYBQ__"